import { Tooltip } from 'react-tooltip'

export default function Tooltips() {
  return (
    <>
      <Tooltip id="dashboard-menu-tooltip" className="z-50 !text-sm !w-40" />
      <Tooltip id="reports-menu-tooltip" className="z-50 !text-sm !w-40" />
    </>
  )
}
